export default __webpack_public_path__ + "static/media/dyr.0dc97a8d.jpg";